const hamburger = document.querySelector('.js-hamburger');
const header = document.querySelector('.js-header');
const headerNavbar = document.querySelector('.js-header-navbar');
let lockIdentificator = 0;

hamburger.addEventListener('click', function() {
    header.classList.toggle('active-menu');
});

window.addEventListener('resize', function() {
    const windowInnerWidth = this.window.innerWidth;

    if(windowInnerWidth <= 991 && lockIdentificator == 0) {
        headerNavbar.classList.add('hide');
        
        setTimeout(() => {
            headerNavbar.classList.remove('hide');

            lockIdentificator = 1;
        }, 301);
    } else if(windowInnerWidth >= 992) {
        if(lockIdentificator !== 0) lockIdentificator = 0;
    };
});